import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import moment from "moment"
import { theme, Text } from "@pallet-hq/hegel"
import { ListingDetails_listing } from "__generated__/ListingDetails_listing"

const ListingDetailsFragment = gql`
    fragment ListingDetails_listing on ListingType {
        id
        postedAt
        postingTier {
            id
            name
        }
        partnership {
            id
            collectivePass {
                id
                name
            }
        }
        poster {
            id
            fullName
            email
        }
    }
`

export type ListingDetailsProps = {
    listing: ListingDetails_listing
}

const ListingDetails = ({ listing }: ListingDetailsProps) => {
    if (!listing.poster || (!listing.postingTier && !listing.partnership)) {
        return null
    }

    const showFullName = !(
        listing.poster.fullName === "Pallet User" ||
        listing.poster.fullName == listing.poster.email
    )

    return (
        <>
            <Text
                variant="uiSmall600"
                textTransform="uppercase"
                color="gray600"
                mb={theme.space.xsmall}
            >
                Job Poster Details
            </Text>
            <ListingDetailsContainer>
                <ListingDetailsInnerContainer>
                    <LeftContainer>
                        {showFullName && (
                            <Text variant="uiSmall500">
                                {listing.poster.fullName}
                            </Text>
                        )}
                        <Text
                            variant="paragraphMedium"
                            color={theme.colors.gray600}
                        >
                            {listing.poster.email}
                        </Text>
                    </LeftContainer>
                    <RightContainer>
                        {listing.postingTier && (
                            <Text variant="uiSmall500">
                                {listing.postingTier.name}
                            </Text>
                        )}
                        {listing.partnership?.collectivePass && (
                            <Text variant="uiSmall500">
                                {listing.partnership.collectivePass.name}
                            </Text>
                        )}
                        <Text
                            variant="paragraphMedium"
                            color={theme.colors.gray600}
                        >
                            {moment(listing.postedAt).format("LL")}
                        </Text>
                    </RightContainer>
                </ListingDetailsInnerContainer>
            </ListingDetailsContainer>
        </>
    )
}

ListingDetails.fragment = ListingDetailsFragment

export default ListingDetails

const ListingDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: ${theme.space.small};
    background: ${theme.colors.white};
    border: 1px solid #dcdde1;
    box-sizing: border-box;
    border-radius: 8px;
    margin-bottom: ${theme.space.small};
`

const ListingDetailsInnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`

const LeftContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.space.xxsmall};
`

const RightContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: ${theme.space.xxsmall};
`
